// Libelles du panneau Navigateur, en francais, repris de l'ancienne app Pirouette (fr.ts,
// browser_live.*). Pas de tiret long ni de nom de marque dans un texte affiche.
import { hoteDe } from "@app/lib/compta/navigateur/adresse";

export const LIBELLES_NAVIGATEUR = {
  titre: "Navigateur",
  precedent: "Précédent",
  suivant: "Suivant",
  recharger: "Recharger",
  adressePlaceholder: "Rechercher ou entrer une adresse…",
  enDirect: "en direct",
  fermer: "Fermer",
  vueEnDirect: "Vue du navigateur en direct",
  indisponible: "Navigateur indisponible. Reconnexion…",
  bloque:
    "La page ne s'affiche plus. Recharge-la, ou demande à l'assistant d'ouvrir une page.",
  nonPrisEnCharge: "Le navigateur en direct n'est pas disponible ici.",
  connexion: "Connexion…",
  terminee: "La session du navigateur est terminée",
  termineeAide:
    "Demande à l'assistant d'ouvrir une page pour relancer le navigateur.",
  sansSession: "L'assistant n'a pas encore ouvert de page",
  tuAsLaMain: "Vous avez la main, clics et clavier actifs",
  rendreLaMain: "Rendre la main",
  piloteParLAssistant: "Navigateur piloté par l'assistant",
  prendreLaMain: "Prendre la main",
  prendreLaMainAide: "Pour résoudre un captcha ou vous connecter à un site",
  modifierAdresse: "Modifier l'adresse",
  adresseInvalide: "Adresse non prise en charge",
  chargement: "Chargement…",
  ouvrirAilleurs: "Ouvrir dans mon navigateur",
  historique: "Pages vues par l'assistant",
  pagesRecentes: "Pages récentes",
  voirLeNavigateur: "Voir le navigateur",
  carteDescription:
    "L'assistant utilise un navigateur que vous pouvez regarder en direct.",
} as const;

export type GesteNavigateur =
  | "open"
  | "click"
  | "type"
  | "read"
  | "login"
  | "work";

const GESTE_PAR_OUTIL: Record<string, GesteNavigateur> = {
  browser_open: "open",
  browser_click: "click",
  browser_type: "type",
  browser_read: "read",
  browser_login: "login",
};

/** Nom d'outil, eventuellement prefixe par le serveur (« serveur__browser_open »). */
export function gesteDeLOutil(
  nomOutil: string | null | undefined
): GesteNavigateur | null {
  if (!nomOutil) {
    return null;
  }
  for (const [outil, geste] of Object.entries(GESTE_PAR_OUTIL)) {
    if (nomOutil === outil || nomOutil.endsWith(`__${outil}`)) {
      return geste;
    }
  }
  return null;
}

export function estOutilNavigateur(
  nomOutil: string | null | undefined
): boolean {
  return gesteDeLOutil(nomOutil) !== null;
}

/** Narration d'un geste de l'assistant (« Ouvre exemple.fr »). */
export function libelleGeste(
  geste: GesteNavigateur,
  url?: string | null
): string {
  switch (geste) {
    case "open": {
      const domaine = url ? hoteDe(url) : "";
      return domaine ? `Ouvre ${domaine}` : "Ouvre une page";
    }
    case "click":
      return "Clique un élément";
    case "type":
      return "Saisit du texte";
    case "read":
      return "Lit la page";
    case "login":
      return "Se connecte au site";
    case "work":
      return "Travaille sur la page";
  }
}
